module.exports = __webpack_public_path__ + "img/img-chart-04.68da1cad.png";